.jt{bottom:0.25rem;}